// extracted by mini-css-extract-plugin
module.exports = {"text":"Page404_text__1ATJI","notFound":"Page404_notFound__4MOie","logo":"Page404_logo__y6bEb"};